// Registro do service worker e recuperação da aba quando a versão troca.
//
// Fica FORA da árvore de componentes de propósito: o aviso visual mora no
// layout autenticado, mas o registro e o socorro precisam valer desde a
// primeira tela — inclusive para quem está no login quando sai um deploy.
//
// O que resolve, medido em 10/09/2026 reproduzindo um deploy real: quando o
// service worker novo assume (porque outra aba clicou em "Recarregar", ou
// porque o navegador ativou o que estava esperando), o precache antigo é
// apagado. A aba que continua rodando o código velho fica sem os arquivos
// dele — some do cache E do servidor, que o deploy substituiu — e quebra na
// primeira coisa carregada sob demanda. Era o "depois do deploy fica bugado
// até dar F5".
let recarregando = false;

const recarregarUmaVez = () => {
  if (recarregando) return;

  recarregando = true;
  window.location.reload();
};

export const cuidarDaVersaoNova = () => {
  // O controlador mudou: o código que esta aba executa deixou de ter suporte
  // do cache. Recarregar aqui é o contrário de atrapalhar — sem isso a tela
  // fica meio viva até alguém apertar F5.
  navigator.serviceWorker?.addEventListener(
    "controllerchange",
    recarregarUmaVez
  );

  // Arquivo sob demanda que não existe mais (evento do próprio Vite). Mesmo
  // estrago por outro caminho: deploy sem troca de service worker, ou aba
  // aberta desde antes do deploy anterior.
  window.addEventListener("vite:preloadError", recarregarUmaVez);
};

export default cuidarDaVersaoNova;
